import React from "react";
import styles from "./formSection.module.scss";
import ContactUsForm from "@components/shared/contactUs/contactUsForm";

const FormSection: React.FC = () => {
    return (
        <div className={`${styles.bg}`}>
            <div className="flex flex-col lg:flex-row justify-between pt-36 pb-16 px-4">
                <div className="flex flex-col justify-center lg:w-6/12 mb-8">
                    <div className="flex flex-col mb-8">
                        <img
                            src="/assets/letter.png"
                            alt=""
                            className="w-16 mb-3"
                        />
                        <h1 className="font-bold text-xl w-9/12">
                            Any Question or remarks? Just write us a message!
                        </h1>
                        <p className="w-9/12">
                            Fill up the form and our team will get back to you
                            within 24 hours
                        </p>
                    </div>
                    <div className="flex flex-col text-sm">
                        <img
                            src="/assets/location.png"
                            alt=""
                            className="w-16 mb-3"
                        />
                        <p>
                            Dorrat khalda complex, Fourth floor <br />
                            <b>Amman, Jordan, 11831</b>
                        </p>
                        <p>P.O Box 217, ZipCode 11831</p>
                        <p>
                            Phone{" "}
                            <span className="font-bold">
                                +962 (06) 2000 102 (Ext: 4866)
                            </span>
                        </p>
                    </div>
                </div>
                <div className={`lg:w-6/12 p-10 bg-white`}>
                    <ContactUsForm
                        primaryColor="#5dbbfe"
                        secondaryColor="#000000"
                        classes={{
                            formClassName: styles["form"],
                            fieldWrapperClassName: styles["field-wrapper"],
                            fieldClassName: styles["field"],
                        }}
                    />
                </div>
            </div>
        </div>
    );
};
export default FormSection;
